<template>
  <div>
    <section class="cart-section" style="padding:30px 0px 15px 0px;">
      <div class="container" style="margin-bottom:10px">
        <form id="formSIF" v-on:submit.prevent="onSubmit">
          <div class="">
            <div class="container padding-cls">
              <div class="checkout-page">
                <div class="checkout-form theme-form">
                  <div class="row center-content">
                    <div class="col-lg-12 col-sm-12 col-xs-12">
                      <div class="theme-card check-out ng-star-inserted">
                        
                        <div class="row">

                          <div class="col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" style="margin-right: 30px; text-align:justify">CU admission process <span v-if="stillInterestedUnits!=''" class="badge-dark px-2 py-1"> for unit <b>{{stillInterestedUnits}}</b></span> is going to be closed soon. If you are still interested for admission please put tick mark below.</label>

                              <!--CU admission process is going to be closed soon. If you are still interested for admission in the departments mentioned in <a href="https://drive.google.com/file/d/1Ugzf6Y11y2YMxCcYhNhppcFoKJmkhGWa/view" target="_blank"><img src="../../theme-assets/images/icon/google-drive.png" style="width: 20px; height:20px;"/></a> please put tick mark below.-->
                            </div>
                          </div>

                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check" style="margin-left:30px; padding-left:0px;">
                              <input class="form-check-input" type="checkbox" id="still_interested" name="still_interested" v-model="stillInterested" :disabled="!openStillInterested || closeStillInterested || stillInterested==1" @change="setStillInterested">
                              <label class="form-check-label" for="still_interested" style="margin-left: 0px;">Yes. I am still interested.</label> 
                              <i v-if="isProcessing" class="fa fa-spinner fa-spin ml-2">&nbsp;</i>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import { GET_STILL_INTERESTED, SET_STILL_INTERESTED } from '../../const/api'
import { GET, POST } from '../../utils/Request'
import moment from 'moment'

export default {
  name: 'ProfileSif',
  components: { Loader },
  data() {
    return {
      
      openStillInterested : false,
      closeStillInterested : true,
      stillInterested : false,
      showStillInterested : false, 
      stillInterestedUnits : '',

      isProcessing : false,
    }
  },
  created() {
    this.getStillInterested();
  },
  
  methods: {
  
    reloadSIF() {
      this.getStillInterested();
    },

    async setStillInterested() {
      this.isProcessing = true;
      
      /*console.log(this.stillInterested);*/

      var data = await POST(SET_STILL_INTERESTED, {still_interested:this.stillInterested});
      // console.log('updating', data.data);

      this.isProcessing = false;
      switch(data.data.status) {
        case 'info' :
          this.$iziToast.info({message: data.data.message});
          break;
        case 'error' :
          this.$iziToast.error({message: data.data.message});
          break;
        case 'success' :
          this.$iziToast.success({message: data.data.message});
          break;
        default:
          this.$iziToast.error({message: 'Unable to process! Please try again.'});
      }
    },

    async getStillInterested(){

      this.isProcessing = true;
      var data = await GET(GET_STILL_INTERESTED);
      /*console.log(data.data);*/
      this.isProcessing = false;
      
      if(data.data.status == 'success'){
        this.openStillInterested = data.data.openStillInterested;
        this.closeStillInterested = data.data.closeStillInterested;
        this.stillInterested = data.data.stillInterested;
        this.showStillInterested = data.data.showStillInterested;
        this.stillInterestedUnits = data.data.units;

        // console.log('loading', this.openStillInterested, this.closeStillInterested, this.stillInterested, 
        /*:disabled="!openStillInterested || closeStillInterested || stillInterested"*/
        /* loading true false 0 true */
        // this.showStillInterested);
      }
      else {
        // console.log(data.data.status);
        this.$iziToast.error({message: data.data.message});
      }
      /*console.log(this.stillInterested);*/
    },

    async onSubmit(){
      
      /*console.log(this.sif);*/

      this.choice.btn_action=='save' ? this.isSaving = true : this.isSubmiting = true;
      let response = await POST(POST_SIF, this.sif);
      this.isSaving = this.isSubmiting = false;

      /*console.log(response);*/

      this.missingError = false;
      this.missingMsg = '';

      if(response.status=='200'){
          let type = response.data.status;
          if(type=='success'){
            let msg = response.data.message;
            this.getStillInterested();
            this.$iziToast.success({
                message: msg
            });
          }
          else{
            let msg = response.data.message;
            if(type=='info'){
              this.$iziToast.info({
                  message: msg
              });
            }else if(type=='missing'){
              this.missingError = true;
              this.missingMsg = response.data.message;
            } else{
                this.$iziToast.error({
                  /*message: msg*/
              });
            }
          }
      }
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.loader {
  margin-top: 20%;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.form-group input:not([disabled]), 
.form-group select:not([disabled]),
.form-group textarea:not([disabled]) {
  background-color: white;   
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
   box-sizing: border-box;
}
.flower-spinner{
  margin: auto;
}

</style>